import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ADVOCATES_PSF_TASKS = createFcmDetails('advocates_psf_tasks', {
	owner: /* TODO */ '',
	context: /* TODO */ '',
	description: /* TODO */ '',
	import: false,
});
